import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCompassFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM16.2427 7.75734C15.8891 7.40379 11.2929 8.46445 9.87873 9.87866C8.46452 11.2929 7.40386 15.8891 7.75741 16.2426C8.11097 16.5962 12.7072 15.5355 14.1214 14.1213C15.5356 12.7071 16.5962 8.1109 16.2427 7.75734ZM12 11C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11Z" })
});
export default SvgCompassFill;
